/* eslint-disable @typescript-eslint/strict-boolean-expressions */
// istanbul ignore file
import { APIConfiguration } from '../../../utils/apiConfiguration'
import interceptedAxios from '../../../utils/interceptedAxios'
interface AssetIntervalReadingData {
  readingTime: string
  value: number | null
}
interface AssetIntervalReading {
  parameterId: string
  parameterName: string
  units: string | null
  assetIntervalReadingData: AssetIntervalReadingData[]
}

interface Device {
  deviceId: string
  assetIntervalReading: AssetIntervalReading[]
}

export interface IFlameSignalData {
  error: boolean
  httpStatus: number
  data: Device
}

export async function getFlameSignaGraphData (
  startDateTime: string,
  endDateTime: string,
  request: string,
  isDefault: boolean,
  onSuccess: (metadata: IFlameSignalData | null, httpStatus: number) => void,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/device/data?startDateTime=${startDateTime}&endDateTime=${endDateTime}&isDefault=${isDefault.toString()}`
  interceptedAxios
    .post(url, request, {
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      const responseData = response.data
      console.log(responseData, 'responseDataresponseData')
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.message, error.response.status)
        }
      } else {
        if (error.code === 'ECONNABORTED') { onFailure(error.message, APIConfiguration.REQUEST_TIMEOUT) } else onFailure('Network Failure', error.status)
      }
    })
}
